const CABINET_QUERY_PARAMS_FOR_LIGHTBOX_PRIMARY = "?preset=3:2-md&presetScale=3/4service=lightbox&dpr=1", CABINET_QUERY_PARAMS_LIGHTBOX_CAROUSEL = "?preset=3:2-sm&presetScale=1/8&service=lightbox&dpr=1";
export {
  CABINET_QUERY_PARAMS_FOR_LIGHTBOX_PRIMARY,
  CABINET_QUERY_PARAMS_LIGHTBOX_CAROUSEL
};
